/**
 * Hospitalization-related constants shared between backend and frontend
 */

export type HospitalizationActionTypes = 'admitted' | 'discharged';

export const FOLLOW_UP_SURVEY_KEY = 'hospitalization-follow-up';
export const FOLLOWUP_HEDIS_MEASURES = ['FUA', 'FUM', 'FUH'];
export const FOLLOWUP_DATE_QUESTION_KEY = 'expected-completion-date';
export const BH_APPOINTMENT_SURVEY_KEY = 'connection-to-bh-care';
